import { DeclarationsModule } from "../../declarations/DeclarationsModule"

export function DeclarationsPage() {
  return (
    <div data-agent-target="declarations.list" className="min-h-full">
      <DeclarationsModule />
    </div>
  )
}
